<div class="job-order-filter-container">
  <form class="job-order-filter-form" [formGroup]="formGroup">
    <mat-label>Filters</mat-label>
    <mat-form-field>
      <input
        matInput
        placeholder="Customer"
        formControlName="jobCustomer"
        minlength="1"
      />
    </mat-form-field>

    <mat-form-field>
      <input
        matInput
        placeholder="Job name"
        formControlName="jobName"
        minlength="1"
      />
    </mat-form-field>

    <mat-form-field>
      <input
        matInput
        placeholder="Job machine"
        formControlName="jobMachine"
        minlength="1"
      />
    </mat-form-field>

    <mat-label>Filter on date</mat-label>

    <app-date-quick-chips
      [activeKey]="activeChip"
      (rangeSelected)="onQuickRange($event)"
    ></app-date-quick-chips>

    <mat-radio-group matInput formControlName="date" (change)="onChange()">
      <mat-radio-button value="NONE">None</mat-radio-button>
      <mat-radio-button value="CUSTOM">Custom</mat-radio-button>
    </mat-radio-group>

    <mat-form-field appearance="outline">
      <input
        placeholder="From date"
        matInput
        [matDatepicker]="fromDate"
        formControlName="fromDate"
      />
      <mat-datepicker-toggle matSuffix [for]="fromDate"></mat-datepicker-toggle>
      <mat-datepicker #fromDate></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <input
        placeholder="To date"
        matInput
        [matDatepicker]="toDate"
        formControlName="toDate"
      />
      <mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
      <mat-datepicker #toDate></mat-datepicker>
    </mat-form-field>

    <button
      [disabled]="!formGroup.valid"
      mat-stroked-button
      color="accent"
      class="btn"
      (click)="onApply()"
    >
      Apply
    </button>
  </form>
</div>
